(function(){
  if(window.__wwHome) return; window.__wwHome=true;
  var d=document, root=d.documentElement;
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var idle=window.requestIdleCallback||function(f){return setTimeout(f,200)};
  function init(){
    root.classList.add('ww-js');
    [].forEach.call(d.querySelectorAll('[data-ww-tabs]'),function(box){
      var tabs=[].slice.call(box.querySelectorAll('[role=tab]'));
      function sel(t,focus){tabs.forEach(function(x){var on=x===t;x.setAttribute('aria-selected',on);x.tabIndex=on?0:-1;var p=d.getElementById(x.getAttribute('aria-controls'));if(p)p.hidden=!on;});if(focus)t.focus();}
      tabs.forEach(function(t,i){
        t.addEventListener('click',function(){sel(t);});
        t.addEventListener('keydown',function(e){var k=e.key,n=null;
          if(k==='ArrowRight')n=tabs[(i+1)%tabs.length];
          if(k==='ArrowLeft')n=tabs[(i-1+tabs.length)%tabs.length];
          if(k==='Home')n=tabs[0];
          if(k==='End')n=tabs[tabs.length-1];
          if(n){e.preventDefault();sel(n,true);}});
      });
    });
    var rvs=[].slice.call(d.querySelectorAll('.ww .rv'));
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{rootMargin:'0px 0px -8% 0px'});
      rvs.forEach(function(el){io.observe(el);});
    } else { rvs.forEach(function(el){el.classList.add('in');}); }
    var frame=d.getElementById('wwDayFrame'),tEl=d.getElementById('wwDialTime'),lEl=d.getElementById('wwDialLabel');
    var steps=[].slice.call(d.querySelectorAll('.ww .step'));
    if(frame&&steps.length&&'IntersectionObserver' in window){
      var so=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){var i=steps.indexOf(e.target);steps.forEach(function(s){s.classList.toggle('is-active',s===e.target);});
        frame.setAttribute('data-active',i);tEl.textContent=e.target.getAttribute('data-time');lEl.textContent=e.target.getAttribute('data-label');}});},{rootMargin:'-45% 0px -45% 0px'});
      steps.forEach(function(s){so.observe(s);});
    }
    [].forEach.call(d.querySelectorAll('[data-ww-rail]'),function(box){
      var rail=box.querySelector('.rail'),prev=box.querySelector('[data-prev]'),next=box.querySelector('[data-next]');
      if(!rail||!prev||!next) return;
      function step(){var c=rail.querySelector('.card');return c?c.getBoundingClientRect().width+24:300;}
      prev.addEventListener('click',function(){rail.scrollBy({left:-step()*2,behavior:reduce?'auto':'smooth'});});
      next.addEventListener('click',function(){rail.scrollBy({left:step()*2,behavior:reduce?'auto':'smooth'});});
      function st(){if(!rail.clientWidth)return;prev.disabled=rail.scrollLeft<8;next.disabled=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-8;}
      rail.addEventListener('scroll',st,{passive:true});
      /* 2026-10-13 效能：初始狀態延到閒置時再算，避免首繪前強制重排；畫面外區塊使用 content-visibility，進入畫面時才有尺寸需重算 */
      idle(st);
      var wrap=box.closest('.shopify-section')||box;
      wrap.addEventListener('contentvisibilityautostatechange',function(e){if(!e.skipped)st();});
      window.addEventListener('resize',st,{passive:true});
    });
  }
  if(d.readyState!=='loading') init(); else d.addEventListener('DOMContentLoaded',init);
})();
